module.exports = __webpack_public_path__ + "img/rem9.64f10b8e.jpg";